<template>
  <div class="pagination-container">
    <el-pagination
      :current-page="listQuery.page"
      :page-sizes="pageSizes ? pageSizes : [15]"
      :page-size="Number(listQuery.limit)"
      :total="listQuery.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Paginator',
  props: {
    listQuery: {
      type: Object,
      required: true,
      validator: function (value) {
        let fields = ['limit', 'page', 'total']
        for(let i = 0; i < fields.length; i++) {
          if (!(fields[i] in value)) {
            return false
          }
        }
        return true
      }
    },
    pageSizes: {
      type: Array,
      required: false,
    }
  },
  created() {
    // this.value.limit=15
  },
  methods: {
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.listQuery.size = val
      this.listQuery.page = 1
      this.$emit('paginator-change')
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.$emit('paginator-change')
    }
  }
}
</script>

<style scoped>

</style>
